<template>
    <base-modal class="form-save-modal" :loading="loading" :title="__('form/unsaved_title')" :body="message || __('form/unsaved_body')">
        <template #footer>
            <panel>
                <btn theme="light" size="lg" :label="__('form/cancel')" @click="clickAction('abort')" class="mr-md-auto"/>
                <btn theme="light" size="lg" :label="__('form/discard')" @click="clickAction('discard')"/>
                <btn size="lg" :label="__('form/save')" @click="clickAction('save')"/>
            </panel>
        </template>
    </base-modal>
</template>

<script>
    export default {
        props: {
            message: String,
            callback: Function,
        },

        data() {
            return {
                loading: false,
            };
        },

        methods: {
            async clickAction(action) {
                this.loading = true;
                await this.callback(action);
                this.$emit('close');
            },
        },
    };
</script>
